module.exports = __webpack_public_path__ + "static/media/mockup-main-header.930a1b86.png";